import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IIziPayRequestConfig, IIziPaymenGatewaytResponse } from '../classes/payment.interfaces';
import { IMakeTransferResponse } from './interfaces/izipai-make-transfer.interfaces';

export interface IEvent {
  code: string;
  description: string;
  ws_token?: string;
  infoBilling?: IBillingInfo;
  infoIzipay?: IIziPayRequestConfig; // es la informacion obtenida por lado de opbk
  paymentGateway?: IIziPaymenGatewaytResponse;
  paymentTranfer?: IMakeTransferResponse;

}

export interface IBillingInfo {
  doc_type: string;
  dni: string;
  name: string;
  lastname: string;
  email: string;
  phone: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentBusEventsService {
  private eventBus = new BehaviorSubject<IEvent>({} as IEvent);
  eventBus$ = this.eventBus.asObservable();

  sendEvent(event: IEvent): void {
    this.eventBus.next({ ...this.eventBus.value, ...event });
  }

  getCurrentEvent(): IEvent {
    return this.eventBus.value;
  }

  reset(): void {
    this.eventBus.next({} as IEvent);
  }
}
